// The Apple refunds view became a tab of the App Store view. Redirect before
// the page renders: a view mounted under the old id would keep that id as its
// own and stop writing its tab and filters to the URL.
export default defineNuxtRouteMiddleware((to) => {
  if (!['/admin', '/ad'].includes(to.path)) return
  const view = Array.isArray(to.query.view) ? to.query.view[0] : to.query.view
  if (view !== 'appstore-refunds') return
  return navigateTo({ path: to.path, query: { ...to.query, view: 'appstore' }, hash: to.hash }, { replace: true })
})
